import PropTypes from "prop-types";
import "./ServicesSection.css";

function ServicesSection({ items }) {
  return (
    <section className="services" id="services" data-reveal>
      <div className="services__header">
        <span className="services__eyebrow">Services</span>
        <h2 className="services__title">
          From strategy to shipped outcomes, we guide the full journey.
        </h2>
        <p className="services__intro">
          Engage us for targeted accelerators or full lifecycle delivery programs. We align to your
          constraints and ensure every initiative ladders up to measurable value.
        </p>
      </div>
      <div className="services__grid">
        {items.map((service, index) => (
          <article
            key={service.title}
            className="service-card"
            data-reveal
            data-reveal-delay={index * 100}
          >
            <h3 className="service-card__title">{service.title}</h3>
            <p className="service-card__description">{service.description}</p>
            <div className="service-card__divider" />
            <ul className="service-card__list">
              {service.outcomes.map((outcome) => (
                <li key={outcome} className="service-card__item">
                  {outcome}
                </li>
              ))}
            </ul>
          </article>
        ))}
      </div>
    </section>
  );
}

ServicesSection.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      outcomes: PropTypes.arrayOf(PropTypes.string).isRequired
    })
  ).isRequired
};

export default ServicesSection;
